import { useLocalization } from '@/hooks/useLocalization';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button } from '@mui/material';
import React from 'react';
import FlyoutHeader from '../common/FlyoutHeader';
import { ClientHeaderProps } from '../types';

const ClientHeader: React.FC<ClientHeaderProps> = ({
  isFetching,
  client,
  action,
  headingId,
}) => {
  const { t } = useLocalization();
  const backAction =
    action.kind === 'back' ? (
      <Button
        variant='text'
        startIcon={<ArrowBackIcon />}
        onClick={action.onClick}
        sx={{
          minHeight: 44,
          transition: (theme) =>
            theme.transitions.create(['background-color', 'color'], {
              duration: theme.transitions.duration.shortest,
            }),
          '@media (prefers-reduced-motion: reduce)': {
            transition: 'none',
          },
        }}
      >
        {t('backToClients', 'Back to Clients')}
      </Button>
    ) : undefined;

  return (
    <FlyoutHeader
      title={client.Name}
      subtitle={client.UserName}
      onClose={action.kind === 'close' ? action.onClick : undefined}
      closeLabel={t('close', 'Close')}
      isFetching={action.kind === 'close' ? isFetching : false}
      actions={backAction}
      titleHeading={headingId ? { id: headingId } : undefined}
    />
  );
};

export default React.memo(ClientHeader);
